// Ghana Regions Data
export const regions = [
  { id: 'greater-accra', name: 'Greater Accra' },
  { id: 'ashanti', name: 'Ashanti' },
  { id: 'western', name: 'Western' },
  { id: 'eastern', name: 'Eastern' },
  { id: 'volta', name: 'Volta' },
  { id: 'central', name: 'Central' },
  { id: 'northern', name: 'Northern' },
  { id: 'upper-east', name: 'Upper East' },
  { id: 'upper-west', name: 'Upper West' },
  { id: 'western-north', name: 'Western North' },
  { id: 'ahafo', name: 'Ahafo' },
  { id: 'bono', name: 'Bono' },
  { id: 'bono-east', name: 'Bono East' },
  { id: 'oti', name: 'Oti' },
  { id: 'savannah', name: 'Savannah' },
  { id: 'north-east', name: 'North East' }
];

export default regions;
